import Breadcrumbs from '@v2/shared/components/Breadcrumbs';
import ContentCard from '@v2/shared/components/ContentCard';
import PageHeading from '@v2/shared/components/PageHeading';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

/**
 * /about-us.
 *
 * The copy is the legacy page's, word for word. DiscountMags' About Us was rewritten when
 * it moved to V2; this one is a framework change only, so nothing here says anything the
 * page did not say before.
 */
export default function AboutUs() {
  const { buildUrl } = useUrlGenerator();

  return (
    <>
      <Breadcrumbs items={[{ label: 'Home', href: '/' }, { label: 'About Us' }]} />

      <PageHeading eyebrow="Customer Information">About Us</PageHeading>

      <div className="prose mt-6 flex flex-col gap-6">
        <ContentCard>
          <p>
            TopMags.com strives to offer you the best value for your magazine subscriptions. We have
            a selection of over 1000 magazines, shipped to your mailbox directly from the publisher.
          </p>

          <p>
            When ordering through TopMags.com, you will receive the best service the industry has to
            offer. We use secure encrypted connections to process your order and will never sell
            your information to any third parties.
          </p>

          <p>
            TopMags.com is not officially affiliated with or endorsed by any magazine publisher.
            Magazine names, logos, and images may be registered trademarks of individual magazines,
            publishers, or parent companies.
          </p>

          <p>
            If you have any questions, feel free to <a href={buildUrl('/contact')}>contact us</a> at
            anytime.
          </p>
        </ContentCard>
      </div>
    </>
  );
}

AboutUs.layoutName = 'Layouts.Institutional';
